import { Menu } from "lucide-react";
import React from "react";
import { useAppStore } from "../../store/useAppStore";
import { Button } from "../ui/button";

/**
 * Mobile-only nav bar.
 *
 * There is no app chrome above the page any more — the rail carries the brand,
 * navigation and the account menu, and the page starts at the top of the
 * viewport. Below `lg` the rail is hidden, so this is the one thing that has to
 * survive: something to open the drawer.
 *
 * It renders nothing at all on desktop.
 */
export function Header() {
  const { setMobileNavOpen } = useAppStore();

  return (
    <header className="flex h-14 shrink-0 items-center border-b border-sidebar-border bg-sidebar px-4 text-sidebar-foreground lg:hidden">
      <Button
        variant="ghost"
        size="icon-sm"
        onClick={() => setMobileNavOpen(true)}
        aria-label="Open navigation"
      >
        <Menu className="h-4 w-4" />
      </Button>
    </header>
  );
}
